import React, { useContext } from 'react';
import { AppState } from "../Home";
import Stat from './Stat';
import Info from './Info';
import Bar from './ProgressBar';
import '../main.css';
import './CharacterPanel.css';
import { usePlayerStore } from '../store/store';

function CharacterPanel({ sendMessage }) {
    const context = useContext(AppState);
    const {experience, selfTargeted } = context;
    const playerInfo = usePlayerStore((state) => state.pInfo);
    const playerStats = usePlayerStore((state)=> state.playerStats);
    const gold = usePlayerStore((state) => state.gold);
    const formatGold = gold.toLocaleString();

    const handlePortraitClick = () => {
        if (sendMessage && playerInfo?.name) {
            // Send self-targeting message in format: 345false/characterName
            sendMessage('345false/' + playerInfo.name);
        }
    };
    return (
        <>
            <section className="bah" >
                <section className="character-section">
                    <img 
                        className={`image clickable-portrait ${selfTargeted ? 'portrait-selected' : ''}`}
                        src={require('../Assets/gfx/' + playerInfo.picId + '.webp')} 
                        alt='Click to target self'
                        onClick={handlePortraitClick}
                        title='Click to target yourself'
                    />
                    <div className='character-info'>
                        <Info name="Name" value={playerInfo.name} />
                        <Info name="Level" value={playerStats.level} />
                        <Info name="Class" value={playerInfo.clazz} />
                        <Info name="Race" value={playerInfo.race} />
                        <Bar experience={experience} />
                    </div>
                </section>
                <section className='character-stats'>
                    <Stat name="Strength" base={playerStats.str} mod={playerStats.mstr} />
                    <Stat name="Wisdom" base={playerStats.wis} mod={playerStats.mwis} />
                    <Stat name="Agility" base={playerStats.agi} mod={playerStats.magi} />
                    <Stat name="Intelligence" base={playerStats.intel} mod={playerStats.mintel} />
                    <Stat name="Toughness" base={playerStats.tog} mod={playerStats.mtog} />
                    <Stat name="Charisma" base={playerStats.chr} mod={playerStats.mchr} />
                    <Stat name="Armour" base={playerStats.armour} mod={0} className="armour-value" />
                    <Stat name="Gold" base={formatGold} mod={0} className="gold-value" />
                </section>
            </section >
        </>
    );
}

export default CharacterPanel;